import * as TYPES from './type';
export default {
  //授课讨论
  [TYPES.SK_DISCUSS_LIST](state, {
    result
  }) {
    state.SKDiscussList = result.result
  },
  //讨论详情
  [TYPES.SK_DISCUSS_DETAILS](state, {
    result
  }) {
    state.SKDiscussDetails = result.result
  },
  //讨论添加
  [TYPES.SK_DISCUSS_ADD](state, {
    result
  }) {
    state.SKDiscussAdd = result.result
  },
  //讨论结束
  [TYPES.SK_DISCUSS_OVER](state, {
    result
  }) {
    state.SKDiscussOver = result.result
  },
  //讨论结果
  [TYPES.SK_DISCUSS_RES](state, {
    result
  }) {
    state.SKDiscussRes = result.result
  },
  //讨论结果---词云
  [TYPES.SK_DISCUSS_WORD](state, {
    result
  }) {
    state.SKDiscussWord = result.result
  },
  //讨论结果点赞
  [TYPES.SK_DISCUSS_PRAISE](state, {
    result
  }) {
    state.SKDiscussPraise = result.result
  },
}



// WEBPACK FOOTER //
// ./src/store/give-course/discuss/mutations.js